import { render, staticRenderFns } from "./AdminAreaBranchDetailTab.vue?vue&type=template&id=da55b364&"
import script from "./AdminAreaBranchDetailTab.vue?vue&type=script&lang=js&"
export * from "./AdminAreaBranchDetailTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports